exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".exam-select-blank-wrap .blank-seq[data-v-70a95634]{height:14px;width:14px;line-height:14px;display:inline-block;font-size:12px;text-align:center;border-radius:50%;border:1px solid #999}.exam-select-blank-wrap .blank-text[data-v-70a95634]{display:inline-block;border-bottom:1PX solid #333;padding:0 16px;cursor:pointer;overflow-x:scroll;white-space:nowrap;line-height:24px;text-align:center;font-size:16px}", ""]);

// exports
